module.exports = __webpack_public_path__ + "media/images/lp/1/achievement1-sp-a445904e18db241e4744e7cb938ccbe4.png";